import { useTranslation } from "react-i18next";
import { formatDateTime } from "../../lib/format";
import { deadlineState, deadlineTone, type DeadlineState } from "../../pages/complaintsFilter";

/**
 * How one of the two clocks on a complaint stands. The workshop of 11.09.2026 set them at 24 hours for
 * the first answer and seven days for the final one, in calendar time.
 *
 * <p>A complaint filed before the deadlines existed carries none, and then the tag says so instead of
 * showing a green tick that would claim a deadline was met.
 */
export function ComplaintDeadlineTag({
  dueAt,
  answeredAt,
}: {
  dueAt: string | null;
  answeredAt: string | null;
}) {
  const { t } = useTranslation();
  const state: DeadlineState = deadlineState(dueAt, answeredAt);
  const label = {
    none: t("complaints.deadline.none", "nije postavljen"),
    met: t("complaints.deadline.met", "u roku"),
    due: t("complaints.deadline.due", "u toku"),
    missed: t("complaints.deadline.missed", "prekoračen"),
  }[state];
  return (
    <span
      className={`tag ${deadlineTone(state)}`}
      title={dueAt ? t("complaints.deadline.dueAt", "Rok: {{at}}", { at: formatDateTime(dueAt) }) : undefined}
    >
      {label}
    </span>
  );
}
